import React, { useState, useEffect, useLayoutEffect } from 'react'
import './homepage.css'
import { trackPageView } from '../../elements/tracking/pagesAndMarketingTracking.js'
import InsuranceFeatures from './insuranceFeatures/insuranceFeatures.js'
import ListingRentCTA from '../listRentCTA/listRentCTA.js'
import HowItWorks from './howitworks/howitworks'
import HomeMeta from './homeMeta.js'
import HomeHero from './heroImage/homeHero'
import HomeDetails from './details/homeDetails.js'
import HomeReviews from './homeReview/homeReview'
import HomeBlogPosts from '../blogPosts/homeBlogPosts'
import HomePageBrands from './brands/homePageBrands'
import HomePageLocations from './locations/homePageLocations'
import { auth } from 'components/auth/auth'
import { Header } from 'components/elements'

const HomePage = (props) => {
  const isLoggedIn = auth.isAuthenticated()
  const isTripTaken = Number(auth.userRideTakenCount()) > 0

  useEffect(() => {
    trackPageView('Home', 'Marketing')
    document.body.classList.add('home-page')
  }, [])

  useLayoutEffect(() => {
    return () => {
      document.body.classList.remove('home-page')
      document.body.classList.remove('home-klaviyo-banner')
    }
  }, [])

  useEffect(() => {
    if (!isLoggedIn || !isTripTaken) {
      document.body.classList.add('home-klaviyo-banner')
    } else {
      document.body.classList.remove('home-klaviyo-banner')
    }
  }, [isLoggedIn, !isTripTaken])

  return (
    <>
      <HomeMeta />
      <HomeHero isMobile={props.isMobile} />
      <div className="home-page-wrap on-the-fly-behavior">
        <div className="home-blog-posts-block">
          <div className="container medium">
            <h2 className={`is-size-4 has-text-weight-extra-bold has-black-dark-text ${props.isMobile ? 'has-text-centered mb-1' : 'ml-3 mb-1'}`}>
              Latest Rental Tips and Motorcycle News
            </h2>
            <HomeBlogPosts
              isMobile={props.isMobile}
            />
          </div>
        </div>
        <div className="popular-locations-block">
          <div className="container medium">
            <HomePageLocations isMobile={props.isMobile} />
          </div>
        </div>
        <div className="popular-motorcycle-brands-block">
          <div className="container medium">
            <HomePageBrands isMobile={props.isMobile} />
          </div>
        </div>
        <div className="details-collage-block">
          <div className="container large">
            <HomeDetails />
          </div>
        </div>
        <div className="how-it-works-home-block">
          <div className="container medium">
            <HowItWorks />
          </div>
        </div>
        <InsuranceFeatures />
        <div className="riders-reviews-block">
          <div className="container medium">
            <HomeReviews />
          </div>
        </div>
        <ListingRentCTA />
      </div>
    </>
  )
}

export default HomePage
